export enum AccessFilter{
    All = "All",
    TownhallExclusive = "TownhallExclusive",
    CoworkingExclusive = "CoworkingExclusive"
}